import {useLocation, useParams} from 'react-router-dom';

const useBasePath = () => {
  const location = useLocation();
  const params = useParams();

  return Object.keys(params)
      .reduce(
          (path, key) => path.replace('/' + params[key], '/:' + key),
          location.pathname,
      );
};

export default useBasePath;
